import { subDays, startOfToday } from 'date-fns';
import uniqueId from 'lodash.uniqueid';

// components
import ButtonPseudo from '../button/button-pseudo';
import { CustomSelectorProps, DatePickerMode, RangeType } from './types';

// styles
import styles from './rangepicker.module.css';

interface ButtonRange {
  text: string;
  range: RangeType;
}

interface ButtonSingle {
  text: string;
  value: Date;
}

export default function CustomSelector({
  handleCustomDateChange,
  setCustomPeriodSelected,
  mode,
}: CustomSelectorProps): React.JSX.Element {
  const today = startOfToday();

  let buttons: (ButtonRange | ButtonSingle)[];

  if (mode === DatePickerMode.RANGE) {
    buttons = [
      {
        text: 'For all time',
        range: {
          from: undefined,
          to: undefined,
        },
      },
      {
        text: 'Today',
        range: {
          from: today,
          to: undefined,
        },
      },
      {
        text: 'For last 7 days',
        range: {
          from: subDays(today, 7),
          to: today,
        },
      },
      {
        text: 'For last 30 days',
        range: {
          from: subDays(today, 30),
          to: today,
        },
      },
    ];
  } else {
    buttons = [
      {
        text: 'Today',
        value: today,
      },
      {
        text: 'Yesterday',
        value: subDays(new Date(), 1),
      },
      {
        text: '2 days ago',
        value: subDays(new Date(), 2),
      },
      {
        text: '3 days ago',
        value: subDays(new Date(), 3),
      },
    ];
  }

  const handleClick = (value: RangeType | Date) => {
    handleCustomDateChange(value);
  };

  return (
    <div className={styles.rangepickerCustomSelector}>
      {buttons.map((btn: ButtonRange | ButtonSingle) => (
        <ButtonPseudo
          key={uniqueId('-')}
          className="button-white"
          text={btn.text}
          onClick={() => {
            setCustomPeriodSelected(btn.text);

            if ('range' in btn) {
              handleClick(btn.range);
            } else {
              handleClick(btn.value);
            }
          }}
        />
      ))}
    </div>
  );
}
